
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { IMaterial } from "../../../models/materials";
import { saveMaterial } from "../../../redux";

import { useAppDispatch } from "../../../redux/hooks";
import '../../../themes/styles.css';

interface Props {
    onCancel: () => void
}

export const MyForm = ({ onCancel }: Props) => {
    const dispatch = useAppDispatch();

    const onSave = (material: IMaterial) => {
        dispatch(saveMaterial(material) as any);
    }

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Add Material
            </Typography>
            <br />
            <Divider />
            <br />

            <Formik
                initialValues={{
                    name: ''
                }}
                onSubmit={(values) => {
                    onSave(values as any);
                    onCancel();
                }}
            // validationSchema={Yup.object({
            //     name: Yup.string()
            //         .max(15, 'Debe de tener 15 caracteres o menos')
            //         .required('Requerido'),
            // }) } 
            >

                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="id">Book Materials Id</Typography>
                                <Field name="id" type="text" />
                                <ErrorMessage name="id" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="isbn">Isbn</Typography>
                                <Field name="isbn" type="text" />
                                <ErrorMessage name="isbn" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography component="label" htmlFor="name">Name</Typography>
                                <Field name="name" type="text" />
                                <ErrorMessage name="name" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Isbn10">Isbn 10</Typography>
                                <Field name="Isbn10" type="text" />
                                <ErrorMessage name="Isbn10" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Author">Author</Typography>
                                <Field name="Author" type="text" />
                                <ErrorMessage name="Author" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Edition">Edition</Typography>
                                <Field name="Edition" type="text" />
                                <ErrorMessage name="Edition" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Publisher">Publisher</Typography>
                                <Field name="Publisher" type="text" />
                                <ErrorMessage name="Publisher" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="DiscountId">Discount Id</Typography>
                                <Field name="DiscountId" type="text" />
                                <ErrorMessage name="DiscountId" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Weight">Weight</Typography>
                                <Field name="Weight" type="text" />
                                <ErrorMessage name="Weight" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Length">Length</Typography>
                                <Field name="Length" type="text" />
                                <ErrorMessage name="Length" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Width">Width</Typography>
                                <Field name="Width" type="text" />
                                <ErrorMessage name="Width" component="span" className="error-message" />
                                <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Copyright">Copyright</Typography>
                                <Field name="Copyright" type="text" />
                                <ErrorMessage name="Copyright" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="Custom">Custom</Typography>
                                <Field name="Custom" type="text" />
                                <ErrorMessage name="Custom" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="NationalISBN">National ISBN</Typography>
                                <Field name="NationalISBN" type="text" />
                                <ErrorMessage name="NationalISBN" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="AvalibleQuantity">Avalible Quantity</Typography>
                                <Field name="AvalibleQuantity" type="text" />
                                <ErrorMessage name="AvalibleQuantity" component="span" className="error-message" />
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )
                }
            </Formik>
        </Grid >
    )
}

